import * as React from 'react'

function SvgBlogMobileBG(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" viewBox="0 0 376 677" fill="none" {...props}>
      <path
        d="M0 .334v589.469s73.798 69.812 375.18 87.025V110.872C125.052 57.492 0 .334 0 .334z"
        fill="url(#prefix__paint0_radial)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-933.66349 -1713.95437 2749.347 -1497.68567 755.818 1345.46)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgBlogMobileBG
